import { render } from "./AppArticle.vue?vue&type=template&id=3f85728e"
import script from "./AppArticle.vue?vue&type=script&lang=js"
export * from "./AppArticle.vue?vue&type=script&lang=js"

import "./AppArticle.vue?vue&type=style&index=0&id=3f85728e&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__